import { inject, Injectable } from '@angular/core';
import { UserService } from '@app/user';
import { marker } from '@colsen1991/ngx-translate-extract-marker';
import { BehaviorSubject } from 'rxjs';
import { NavMenuItem } from '../models/nav-menu-item';
import { navItemsAccessFilter } from '../../utils';
import { WindowService } from '@app/shared/services';
import { AccessibilityService } from '@app/tw-shared/services';
import { menuItemsFilter } from '../utils';

@Injectable({
    providedIn: 'root',
})
export class MobileHeaderNavItemsService {
    private readonly userService = inject(UserService);
    private readonly windowService = inject(WindowService);
    private readonly accessibilityService = inject(AccessibilityService);

    readonly isVeryLargeFontSize$ = this.accessibilityService.isVeryLargeFontSize$;

    readonly mobileHeaderItems$ = new BehaviorSubject<NavMenuItem[]>([
        {
            name: marker('v3-header-item-my-path'),
            icon: 'path',
            route: ['/my-learning'],
            access: () => this.userService.access.includes('content'),
        },
        {
            name: marker('v3-global-explore'),
            icon: 'binocular',
            route: this.userService.user.company.trial ? ['/explore', 'all-content'] : ['/explore'],
            access: (user) => this.userService.showExploreInHeader && this.userService.access.includes('content') && !user.company.trial,
        },
        {
            name: marker('v3-header-item-practice-hub'),
            icon: 'ai-powered',
            route: ['/practice'],
            access: () => this.userService.hasPracticeHub,
        },
        {
            icon: 'user-plus',
            name: marker('Hiring-helper'),
            route: ['/hire'],
            access: () => this.userService.access.includes('hiring-helper'),
        },
    ]).pipe(
        navItemsAccessFilter(this.userService),
        menuItemsFilter({
            windowService: this.windowService,
            isVeryLargeFontSize$: this.isVeryLargeFontSize$,
        }),
    );
}
